/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateCimdForm,
  CreateCimdForm$Outbound,
  CreateCimdForm$outboundSchema,
} from "../components/createcimdform.js";

export type CreateCimdRemoteSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateCimdRemoteSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateCimdRemoteSessionClientSecurity = {
  option1?: CreateCimdRemoteSessionClientSecurityOption1 | undefined;
  option2?: CreateCimdRemoteSessionClientSecurityOption2 | undefined;
};

export type CreateCimdRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createCimdForm: CreateCimdForm;
};

/** @internal */
export type CreateCimdRemoteSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateCimdRemoteSessionClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateCimdRemoteSessionClientSecurityOption1$Outbound,
    CreateCimdRemoteSessionClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createCimdRemoteSessionClientSecurityOption1ToJSON(
  createCimdRemoteSessionClientSecurityOption1:
    CreateCimdRemoteSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    CreateCimdRemoteSessionClientSecurityOption1$outboundSchema.parse(
      createCimdRemoteSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateCimdRemoteSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateCimdRemoteSessionClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateCimdRemoteSessionClientSecurityOption2$Outbound,
    CreateCimdRemoteSessionClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createCimdRemoteSessionClientSecurityOption2ToJSON(
  createCimdRemoteSessionClientSecurityOption2:
    CreateCimdRemoteSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    CreateCimdRemoteSessionClientSecurityOption2$outboundSchema.parse(
      createCimdRemoteSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateCimdRemoteSessionClientSecurity$Outbound = {
  Option1?: CreateCimdRemoteSessionClientSecurityOption1$Outbound | undefined;
  Option2?: CreateCimdRemoteSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateCimdRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    CreateCimdRemoteSessionClientSecurity$Outbound,
    CreateCimdRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          CreateCimdRemoteSessionClientSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          CreateCimdRemoteSessionClientSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function createCimdRemoteSessionClientSecurityToJSON(
  createCimdRemoteSessionClientSecurity: CreateCimdRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    CreateCimdRemoteSessionClientSecurity$outboundSchema.parse(
      createCimdRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type CreateCimdRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateCimdForm: CreateCimdForm$Outbound;
};

/** @internal */
export const CreateCimdRemoteSessionClientRequest$outboundSchema: z.ZodMiniType<
  CreateCimdRemoteSessionClientRequest$Outbound,
  CreateCimdRemoteSessionClientRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createCimdForm: CreateCimdForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createCimdForm: "CreateCimdForm",
    });
  }),
);

export function createCimdRemoteSessionClientRequestToJSON(
  createCimdRemoteSessionClientRequest: CreateCimdRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    CreateCimdRemoteSessionClientRequest$outboundSchema.parse(
      createCimdRemoteSessionClientRequest,
    ),
  );
}
